import {
  ActivityQuery,
  TimeFormats,
  cn,
  formatDate,
  getStatusColor,
  useTodayProtectedQuery,
} from "@theprelude/core";
import { Loading, ShieldCheckIcon, ShieldFailIcon } from "@theprelude/ds";
export default function ProtectionIndicator({
  query,
}: {
  query: ActivityQuery;
}) {
  const socialQuery = { ...query, impersonate: "social" };
  const { data: protection, isPending } = useTodayProtectedQuery(query);
  const { data: benchmark, isPending: isSocialPending } =
    useTodayProtectedQuery(socialQuery);

  const color = protection ? getStatusColor(protection) : null;
  if (isPending) {
    return (
      <div className="flex min-h-[11.75rem] min-w-[15.25rem] animate-pulse items-center justify-center border-2 border-stroke-line px-6 py-4">
        <Loading />
      </div>
    );
  }

  return (
    <div className="flex min-h-[11.75rem] flex-col justify-center gap-2 bg-surface-background px-6 py-4 dark:border-2 dark:border-stroke-line">
      <div>
        <time>{formatDate(new Date(), TimeFormats.DATE_SHORT)}</time>
        <div className={cn(color, "flex w-48 items-center gap-2")}>
          {color === "text-status-green" && (
            <ShieldCheckIcon className="h-4 w-4" />
          )}
          {color === "text-status-yellow" && (
            <ShieldCheckIcon className="h-4 w-4" />
          )}
          {color === "text-status-red" && (
            <ShieldFailIcon className="h-4 w-4" />
          )}
          <span className="font-regular text-4xl leading-[3.5rem] tracking-tighter">
            {protection}%
          </span>
        </div>
        <p>Protected</p>
      </div>
      <div className="border-t border-stroke-line" />
      {isSocialPending && (
        <div className="flex items-center justify-center gap-1 pt-2">
          <Loading />
        </div>
      )}
      {benchmark !== undefined && (
        <div className="flex items-center gap-1">
          <span className="text-lg leading-6">{benchmark}%</span>
          <span className="text-xs">benchmark</span>
        </div>
      )}
    </div>
  );
}
